import React from 'react'
import ReactIframeResizer from 'react-iframe-resizer-super'

export default class Iframe extends React.Component {
  state = { loaded: false };
  render() {
    return <div style={{position: 'relative', overflow: 'hidden', minHeight: Math.max(50,this.props.height), paddingTop: '2%', paddingBottom: '3%'}}><ReactIframeResizer src={this.props.src}
      iframeResizerOptions={{ initCallback: () => { this.setState({ loaded: true }) } , heightCalculationMethod: 'max'}}
      style={{ width: '100%'}} />
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/iframe.js